import script from "./HonorView.vue?vue&type=script&setup=true&lang=js"
export * from "./HonorView.vue?vue&type=script&setup=true&lang=js"

import "./HonorView.vue?vue&type=style&index=0&id=9c22b3d8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c22b3d8"]])

export default __exports__